export * from './services/sentry-monitoring.service';
export { initializeSentryBrowserClient } from './sentry.client.config';

// Note: initializeSentryServerClient is available via '@kit/sentry/config/server'
// It's not exported here to prevent client-side bundling issues with @sentry/node
